import type { VAxios } from '../../define/axios/Axios';
import { CreateQrCodeRes, QueryQrCodeRes } from '../../entities/uc/wechat.entities';

export const createApi = (defHttp: VAxios) => ({
  // 创建二维码
  createQrCode: () => {
    return defHttp.post<CreateQrCodeRes>({ url: `/uc/wechat/qrcode` });
  },

  // 轮询
  queryQrCode: (params: { id: string }) => {
    return defHttp.get<QueryQrCodeRes>({ url: `/uc/wechat/qrcode`, params });
  },
});
